import { createFileRoute } from '@tanstack/react-router';
import { ReviewPage } from '../features/parent/ReviewPage';
import { RequireAuth } from '../features/auth/RequireAuth';

export const Route = createFileRoute('/parent/review')({
  component: () => <RequireAuth role="parent">{() => <ReviewPage />}</RequireAuth>,
});
